import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { useController, useSuspense } from '@rest-hooks/react';

import UserAccountResource from 'resources/user/UserAccountResource';

import FormSection from 'ui/FormSection';

import UserName from 'utils/localStorage/UserName';

import { Button, FormControl, TextField, Select, MenuItem, InputLabel } from '@mui/material';

import { t } from 'i18n/index';
import i18n from 'i18next';

const PersonalDetailsForm = ({ onError }) => {

    const studentData = useSuspense(UserAccountResource.detail(), {id: 1});

    const [student, setStudent] = useState({...studentData });

    const { fetch } = useController();

    const prevEmail = studentData.email;

    const handleChange = (event) => {
        const {name, value} = event.target;
        let newStudent = {...student};
        if (name === "preferred_language") {
            const newLangCode = value; // value is 'en', 'pt', or 'es'
            newStudent.preferred_language = newLangCode;
            i18n.changeLanguage(newLangCode);
        } else {
            newStudent[name] = value;
        }
        setStudent(newStudent);
    };

    const handleUpdate = useCallback(
        async e => {
            e.preventDefault();
            const {first_name, last_name, email, preferred_language} = student;
            handleValidation(first_name)
            try {
                const { id, name } = await fetch(UserAccountResource.update(), {id: 1}, {first_name, last_name, email, preferred_language});
                if ( id ) {
                    UserName.write(name);
                }
            } catch (error) {
                onError(error);
            }
        },
        [student]
    );

    const handleValidation = (firstName) => {
        validateFirstName(firstName);
    };

    const validateFirstName = (firstName) => {
        if (!firstName){
            onError(t('errors:nameMissing'));
            throw '';
        }
    };

    const {first_name, last_name, email, preferred_language} = student;

    const getDefaultLanguage = () => {
      if (preferred_language) return preferred_language;
      if (navigator.language.startsWith('es')) return 'es';
      if (navigator.language.startsWith('pt')) return 'pt';
      return 'en';
    };

    return (
        <form onSubmit={ handleUpdate } >
            <FormControl fullWidth>
                <FormSection>
                    <TextField
                        fullWidth
                        size='small'
                        name='first_name'
                        label={t('literal:firstName') + " *"}
                        color='warning'
                        value={ first_name }
                        onChange={event => handleChange(event)}
                    />
                    <TextField
                        fullWidth
                        size='small'
                        name='last_name'
                        label={t('literal:lastName')}
                        color='warning'
                        value={ last_name }
                        onChange={event => handleChange(event)}
                    />
                    <TextField
                        fullWidth
                        size='small'
                        name='email'
                        label={t('literal:email')}
                        color='warning'
                        value={ email }
                        disabled={ prevEmail !== '' && prevEmail !== null}
                        onChange={event => handleChange(event)}
                    />

                    <FormControl fullWidth size="small" color="warning">
                        <InputLabel id="language-select-label">{t('student:preferredLanguage')}</InputLabel>
                        <Select
                            labelId="language-select-label"
                            id="language-select"
                            name="preferred_language"
                            value={getDefaultLanguage()}
                            label={t('student:preferredLanguage')}
                            onChange={handleChange}
                        >
                            <MenuItem value="en">{t('literal:english')}</MenuItem>
                            <MenuItem value="pt">{t('literal:portuguese')}</MenuItem>
                            <MenuItem value="es">{t('literal:spanish')}</MenuItem>
                        </Select>
                    </FormControl>
                </FormSection>

                <div className={ `new-form-field-footer` }>
                    <Button variant="contained"
                            color="primary"
                            type="submit"
                    >
                        {t('literal:update')} 
                    </Button>
                </div>
            </FormControl>
        </form>
    );
};

PersonalDetailsForm.propTypes = {
    onError: PropTypes.func,
};

export default PersonalDetailsForm;
